import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Play, Calendar } from 'lucide-react';

const Seasons = () => {
  const seasons = [
    {
      id: 1,
      title: "Season 1: The Inner Office",
      description: "Exploring the intersection of personal growth and professional excellence. Conversations with leaders who navigate office dynamics with wisdom and intention.",
      episodeCount: 12,
      year: "2024"
    },
    {
      id: 2,
      title: "Season 2: InkSpire",
      description: "Book reviews and conversations with authors who challenge conventional thinking. Where ink meets inspiration.",
      episodeCount: 8,
      year: "2025"
    },
    {
      id: 3,
      title: "Season 3: Leadership in the AI Era",
      description: "How leaders are adapting to rapid technological change while staying human-centered. Panel discussions and deep dives.",
      episodeCount: 6,
      year: "2026"
    }
  ];

  return (
    <div className="min-h-screen pt-24 pb-20 bg-dark-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-16 pt-8">
          <p className="text-gold text-xs font-medium uppercase tracking-widest mb-4">
            Browse by Season
          </p>
          <h1 className="text-4xl md:text-5xl font-bold text-warm-white mb-4 tracking-tight">
            All Seasons
          </h1>
          <p className="text-warm-white/60 max-w-2xl">
            Each season explores a distinct theme, bringing together voices and perspectives that challenge, inspire, and transform.
          </p>
        </div>

        {/* Seasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {seasons.map((season) => (
            <Card
              key={season.id}
              className="overflow-hidden hover:border-gold/50 transition-all duration-300 group border border-dark-border bg-dark-card cursor-pointer"
            >
              <div className="h-48 bg-gradient-to-br from-gold/20 to-gold/5 relative flex items-center justify-center">
                <span className="text-8xl font-bold text-gold/20">
                  {String(season.id).padStart(2, '0')}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 bg-gold flex items-center justify-center">
                    <Play className="w-6 h-6 text-dark-bg ml-1" fill="currentColor" />
                  </div>
                </div>
              </div>
              <CardContent className="p-6">
                <div className="flex items-center gap-4 text-xs text-warm-white/50 mb-4 uppercase tracking-wider">
                  <span className="flex items-center gap-1">
                    <Calendar className="w-3 h-3" />
                    {season.year}
                  </span>
                  <span>{season.episodeCount} Episodes</span>
                </div>
                <h3 className="text-xl font-bold text-warm-white mb-3 group-hover:text-gold transition-colors leading-tight">
                  {season.title}
                </h3>
                <p className="text-warm-white/60 text-sm leading-relaxed">
                  {season.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Seasons;
